import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import withBaseComponent from '../../withBaseComponent';

class Delete extends withBaseComponent(React.Component) {
  handleDelete() {
    this.props.accountActions.accountDelete(this.props.account.id).then(res => {
      this.props.toggle && this.props.toggle()
      this.props.onDeleted()
      return res
    })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} className={this.props.className} centered={true}>
        <ModalHeader toggle={this.props.toggle}>{i18n.t('common.delete')}</ModalHeader>
        <ModalBody>
          <div className="form-group" style={{marginBottom: 0}}>
            <div>連携済みの金融機関を削除するとすべてのサービスで明細が削除され、復旧できません。</div>
            <div>（マネーフォワード クラウド会計・確定申告の他の事業者、マネーフォワード クラウド経費、自動家計簿・資産管理サービス「マネーフォワード ME」など）</div>
            <br/>
            <div>連携済みの金融機関を削除してもよろしいですか？</div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
          <button className="btn mfc-btn-red" type="button" onClick={() => this.handleDelete()}>
            {i18n.t('common.delete')}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Delete)
